import { Component, Input } from '@angular/core';

@Component({
    selector: 'form-radio-field',
    template: `
        <div class="form-group form-radio-field">
            <ng-content></ng-content>
            <label>
                {{label}}
            </label>
        </div>
    `
})

export class FormRadioFieldComponent {
    @Input() field: any;
    @Input() name: string;
    @Input() label: string;

}